import { Toggle } from '../../../utilities/toggle.js'

const BREAKPOINT = matchMedia('(min-width: 70rem)')

class Header extends Toggle {
  init () {
    super.init()

    BREAKPOINT.addListener(event => {
      if (event.matches) {
        this.close()
      }
    })
  }

  open () {
    super.open()
    document.body.style.overflow = 'hidden'
  }

  close () {
    super.close()
    document.body.style.overflow = ''
  }
}

const button = document.querySelector('.js-header-button')

if (button) {
  new Header(button).init()
}
